import {DatePicker} from "antd";
import ApexCharts from "apexcharts";
import moment, {min} from "moment";
import React, {useEffect, useMemo, useState} from "react";
import ReactApexChart from "react-apexcharts";
import {useDispatch, useSelector} from "react-redux";
import Tabination from "../../../reusableComponents/Tabination";
import {getAccountMetrics, setDefaultDateForBalanceChart} from "../../../store/reducers/accountSlice";
import "./style.scss";
import ReactECharts from "echarts-for-react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

function FinancialPerformance() {
  const {balance_chart} = useSelector((state) => state.account.accountMetrics.data);

  const items = [
    {name: "Balance", content: <BalanceChart performanceChart={balance_chart} />},
    {name: "Profit", content: <ProfitChart />},
    // { name: "Drawdown", content: <DrawdownChart /> },
  ];

  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="financialperformance-container">
      <h4>Financial Performance</h4>
      <div className="financialperformance-subcontainer">
        <div className="financialperformance-innercontainer">
          <Tabination
            variant={5}
            tabItems={items}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isChart={true}
            isToolbar={true}
            balanceChart={true}
          />
        </div>
      </div>
    </div>
  );
}

export default FinancialPerformance;

  export function FilterChart() {
  const {RangePicker} = DatePicker;
    const dispatch = useDispatch();
    const { idToken } = useSelector((state) => state.auth);
    const { active, start_date, end_date } = useSelector((state) => state.account.accountList);

    const metrics = useSelector((state) => state.account.accountMetrics.data);
    const { email } = useSelector((state) => state.user);
  
    // Se

  // Set default date range (last 7 days)
  const defaultStartDate = dayjs().subtract(7, "days");
  const defaultEndDate = dayjs();
  const [dates, setDates] = useState(start_date && end_date ? [dayjs(start_date), dayjs(end_date)] : []);

  const handleDateRangeChange = async (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      setDates(dates);
      dispatch(setDefaultDateForBalanceChart({start_date: start.format("YYYY-MM-DD"), end_date: end.format("YYYY-MM-DD")}));
      dispatch(
        getAccountMetrics({
          idToken,
          loginId: active,
          start_date: start.format("YYYY-MM-DD"),
          end_date: end.format("YYYY-MM-DD"),
          trading_platform:metrics.trading_platform,
          email:email
        }),
      );
    }
  };

  return (
    <div className="toolbar">
      <RangePicker
        onChange={handleDateRangeChange}
        format="YYYY-MM-DD"
        value={dates}
        disabledDate={(current) => current && current > dayjs().endOf("day")}
      />
    </div>
  );
}

const BalanceChart = ({performanceChart}) => {
  const [balanceChart, setBalanceChart] = useState([]);

  // Set balanceChart when performanceChart is updated
  useEffect(() => {
    setBalanceChart(performanceChart?.length > 0 ? performanceChart : [{balance: 0, equity: 0, time: Date.now()}]);
  }, [performanceChart]);

  // Extract balance and equity data
  const formattedDates = useMemo(() => balanceChart.map((entry) => entry.time), [balanceChart]);
  const balanceData = useMemo(() => balanceChart.map((entry) => entry.balance), [balanceChart]);
  const equityData = useMemo(() => balanceChart.map((entry) => entry.equity), [balanceChart]);

  // Calculate min value for y-axis
  const minValue = useMemo(() => {
    try {
      const allData = [...balanceData, ...equityData];
      return Math.min(...allData);
    } catch (error) {
      console.error("Error calculating min value:", error);
      return Infinity; // Default fallback value
    }
  }, [balanceData, equityData]);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  // Configure the chart options
  const option = useMemo(() => {
    // Define colors based on selectedBrand
    const balanceColor = selectedBrand?.brand === "equity_edge" ? "#80E0C4" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#3F51B5"; // Default Blue

    const equityColor = selectedBrand?.brand === "equity_edge" ? "#36d66b" : selectedBrand?.brand === "crypto_edge" ? "#ED622B" : "#8BC34A"; // Default Green

    return {
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        textStyle: {color: "#000"},
        borderColor: "#ccc",
        borderWidth: 1,
        padding: [10, 15],
        formatter: (params) => {
          const date = dayjs(params[0].name).utc().format("DD MMM YY, HH:mm A");
          const tooltipContent = params
            .map((item) => {
              const itemColor = item.seriesName === "Balance" ? balanceColor : equityColor;
              return `
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <div style="width: 8px; height: 8px; border-radius: 50%; background-color: ${itemColor}; margin-right: 10px;"></div>
                  <span style="color:#000;"><strong>${item.seriesName}:</strong> $${item.value.toFixed(2)}</span>
                </div>
              `;
            })
            .join("");
          return `<div style="font-size: 14px; font-weight: bold;">${date}</div>` + tooltipContent;
        },
      },
      legend: {
        data: ["Balance", "Equity"],
        textStyle: {fontWeight: 700, color: "#fff"},
      },
      grid: {top: 60, left: "3%", right: "4%", bottom: "3%", containLabel: true},
      xAxis: {
        type: "category",
        data: formattedDates,
        axisLabel: {formatter: (value) => dayjs(value).utc().format("DD-MM-YYYY"), color: "#fff"},
      },
      yAxis: {
        type: "value",
        min: minValue,
        axisLabel: {formatter: (value) => `$${value.toFixed(2)}`, color: "#fff"},
      },
      series: [
        {
          name: "Balance",
          type: "line",
          data: balanceData,
          lineStyle: {width: 3, color: balanceColor},
          itemStyle: {
            color: balanceColor, // Yellow fill for markers (and legend marker)
            borderColor: balanceColor, // Yellow border
            borderWidth: 2,
          },
          emphasis: {
            itemStyle: {
              borderColor: balanceColor, // Change this to your desired border color
              borderWidth: 2, // Optional: border thickness
            },
          },
        },
        {
          name: "Equity",
          type: "line",
          data: equityData,
          lineStyle: {width: 3, color: equityColor},
          itemStyle: {
            color: equityColor, // Yellow fill for markers (and legend marker)
            borderColor: balanceColor, // Yellow border
            borderWidth: 2,
          },
          emphasis: {
            itemStyle: {
              borderColor: equityColor, // Change this to your desired border color
              borderWidth: 2, // Optional: border thickness
            },
          },
        },
      ],
    };
  }, [formattedDates, minValue, balanceData, equityData, selectedBrand?.brand]);

  return (
    <div style={{height: "100%"}}>
      {balanceChart.length === 0 ? (
        <div style={{height: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
          <p>Data for the Balance Chart is currently unavailable.</p>
        </div>
      ) : (
        <ReactECharts
          option={option}
          style={{height: "600px"}}
        />
      )}
    </div>
  );
};

export function ProfitChart() {
  const accountsData = useSelector((state) => state.account.accountMetrics);
  const [date, setdate] = useState([]);
  const [profit, setprofit] = useState([]);

  useEffect(() => {
    setdate(accountsData?.data?.profit_chart?.date || []);
    setprofit(accountsData?.data?.profit_chart?.cumulative_profit || []);
  }, [accountsData]);

  const positiveArray = profit?.filter((value) => value > 0);

  const positive = Number(profit);

  const formattedDates = date?.map((dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    });
  });

  const series = [
    {
      name: "Profit",
      type: "column",
      data: positiveArray,
    },
  ];

  const options = {
    grid: {
      show: false, // Hide the horizontal grid lines
    },
    chart: {
      height: 350,
      type: "line",
      toolbar: {
        show: true,
        offsetY: -100,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: false,
        },
        zoom: {
          enabled: false,
        },
      },
    },
    tooltip: {
      enabled: true,
      x: {
        formatter: formattedDates,
      },
    },
    stroke: {
      width: [0, 2],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
    },
    xaxis: {
      categories: formattedDates,
      labels: {
        style: {
          colors: "#fff",
        },
        rotate: 0,
      },
      tickAmount: 6, // Adjust as needed based on your preference
      formatter: function (value, index) {
        // Display every 10th label to avoid clutter
        return index % 10 === 0 ? value : "";
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "10%",
      },
    },
    legend: {
      horizontalAlign: "left",
      offsetX: 40,
      fontWeight: 700,
      markers: {
        radius: 50,
      },
      itemMargin: {
        horizontal: 10,
      },
    },

    yaxis: [
      {
        labels: {
          style: {
            colors: "#fff",
          },
          formatter: (value) => `$${value?.toFixed(2) ?? ""}`,
        },
      },
    ],
    colors: ["#35d269", "#F25F5C"],
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      height={276}
    />
  );
}

export function DrawdownChart() {
  const accountsData = useSelector((state) => state.account.accountMetrics);
  const [date, setdate] = useState([]);
  const [draw_down, setdraw_down] = useState([]);

  useEffect(() => {
    const dateData = accountsData?.data?.drawdown_chart?.date || [];
    const drawDownData = accountsData?.data?.drawdown_chart?.draw_down || [];

    setdate(dateData || []);
    setdraw_down(drawDownData || []);
  }, [accountsData]);

  const negativeArray = draw_down?.filter((value) => value < 0);

  const formattedDates = date?.map((dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    });
  });

  const series = [
    {
      name: "Loss",
      data: negativeArray,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: true,
        offsetY: -10,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: false,
        },
        zoom: {
          enabled: false,
        },
      },
    },
    labels: formattedDates,
    xaxis: {
      labels: {
        style: {
          colors: "#fff", // Change x-axis label color to white
        },
      },
    },

    yaxis: [
      {
        labels: {
          style: {
            colors: "#fff",
          },
          formatter: (value) => `$${Math.abs(value)?.toFixed(2) ?? ""}`,
        },
        max: 10,
      },
    ],

    fill: {},
    tooltip: {
      enabled: true,
      fillSeriesColor: true,
    },
    grid: {
      show: false, // Hide the horizontal grid lines
    },
    plotOptions: {},
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
    },
    legend: {
      position: "bottom",
      show: true,
      horizontalAlign: "left",
      offsetX: 40,
      fontWeight: 700,
      markers: {
        radius: 50,
      },
      itemMargin: {
        horizontal: 10,
      },
    },
    colors: ["#35d269"],
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={276}
    />
  );
}
